export const Balance = {
  path: '/balances',
  name: 'balances',
  component: () => import('@/views/Absence/Balance/BalancePage.vue'),
  children: [
    {
      path: '/balances/add',
      name: 'balances.add',
      component: () => import('@/views/Absence/Balance/Form/BalanceForm.vue'),
      props: { addAction: true }
    },
    {
      path: '/balances/edit/:id',
      name: 'balances.edit',
      component: () => import('@/views/Absence/Balance/Form/BalanceForm.vue'),
      props: { updateAction: true }
    },
    {
      path: '/balances/delete/:id',
      name: 'balances.delete',
      component: () => import('@/views/Absence/Balance/Form/BalanceForm.vue'),
      props: { deleteAction: true }
    },
    {
      path: '/balances/view/:id',
      name: 'balances.view',
      component: () => import('@/views/Absence/Balance/Form/BalanceForm.vue'),
      props: { viewAction: true }
    }
  ]
}